import { Injectable } from '@angular/core';
import { EMPTY, Observable, Subject } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  map,
  shareReplay,
  startWith,
  switchMap,
} from 'rxjs/operators';

import { NegotiationLotsCountGQL } from '../modules/graphql/service/graphql-auto-main-service';

@Injectable({ providedIn: 'root' })
export class NegotiationsService {
  private readonly refresh$ = new Subject<void>();
  readonly hasNegotiations$: Observable<boolean>;

  constructor(countGQL: NegotiationLotsCountGQL) {
    this.hasNegotiations$ = this.refresh$.pipe(
      startWith(undefined),
      switchMap(() =>
        countGQL.fetch({}, { fetchPolicy: 'network-only' }).pipe(
          map((result) => (result.data?.negotiationLotsCount ?? 0) > 0),
          catchError(() => EMPTY),
        ),
      ),
      startWith(false),
      distinctUntilChanged(),
      shareReplay({ bufferSize: 1, refCount: true }),
    );
  }

  refresh(): void {
    this.refresh$.next();
  }
}
